/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { useTranslationBundle } from '../hooks/UNSAFE_useTranslationBundle';
import { BundleType } from '../resources/nls/bundle';
import { preventDefaultForCurrentTarget } from './eventUtils';
import { dropdownStyles } from './themes/dropdownStyles.css';

export function EmptyResults() {
  const translations = useTranslationBundle<BundleType>('@oracle/oraclejet-preact');

  // call preventDefault for mousedown on this div so that focus does not transfer from
  // the input
  return (
    <div class={dropdownStyles.results.extraItem} onMouseDown={preventDefaultForCurrentTarget}>
      {translations.select_noMatchesFound()}
    </div>
  );
}
